module.exports = __webpack_public_path__ + "img/frank_frazetta_deathdealerV.8ae4fb9a.jpg";